export class Pagination<T> {
    constructor(
      public items: T[] = [],
      public page: number =0,
      public pageCount: number=0,
      public pageSize: number = 10,

      public totalRecords?: number,
      public isNumberPagination?: boolean,
      public mergeItems: boolean = false
    ) {}
  
    public hasItems() {
      return this.items && this.items.length > 0;
    }
  
    public updateItems(itemsToMerge: T[]) {
      if (this.mergeItems) {
        this.items = this.items.concat(...itemsToMerge);
      } else {
        this.items = itemsToMerge;
      }
    }
  
    public hasNextPage() {
      if (this.isNumberPagination && this.pageCount && Number(this.page) < this.pageCount) {
        return true;
      }
  
      if (!this.isNumberPagination && this.page) {
        return true;
      }
  
      return false;
    }
  
    public nextPage() {
      if (this.isNumberPagination && this.pageCount && Number(this.page) < this.pageCount) {
        return Number(this.page) + 1;
      } else {
        return this.page;
      }
    }
  }